import ValueFactory from '../../util/ValueFactory';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import DeploymentModel from '../../domain/stream/model/DeploymentModel';
import { ActionJsonModel, ActionSchema } from '../../domain/collection/rule/action/ActionDomains';
import { ActionActions } from '../actions/ActionActions';
import { ApiVariableParameter } from '../../domain/remote/httpVariable/HttpVariableDomains';

export interface ActionState {
  action: ActionJsonModel;
  actionSchema: DeploymentModel<ActionSchema> | null;
  isUpdate: boolean;
  isDirty: boolean;
}

const initialState: ActionState = {
  action: ValueFactory.initializeAction(),
  actionSchema: { stage: 'DRAFT' } as DeploymentModel<ActionSchema>,
  isUpdate: false,
  isDirty: false,
};

export const actionReducer = (state = initialState, action: ReduxBaseAction<any, ActionActions>) => {
  switch (action.type) {
    case 'CHANGE_ACTION':
      return { ...state, action: action.payload, isDirty: true };
    case 'CHANGE_ACTION_SCHEMA':
      return { ...state, actionSchema: action.payload };
    case 'CHANGE_ACTION_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CLEAR_ACTION':
      return { ...state, action: ValueFactory.initializeAction(), actionSchema: null, dependencies: [], isUpdate: false, isDirty: false };
    case 'CHANGE_ACTION_API_VARIABLE_URL':
      const activeParameters = action.payload.parameters.filter((item: ApiVariableParameter) => item.isActive);
      const url = (action.payload.url || 'url').split('?');
      if (activeParameters != undefined && activeParameters.length > 0) {
        action.payload.url = url[0] + '?' + activeParameters.map((item: ApiVariableParameter) => item.key + '=' + item.value).join('&');
      } else {
        action.payload.url = action.payload.url.split('?')[0];
      }
      return { ...state, action: action.payload };
    case 'CHANGE_ACTION_DIRTY':
      return { ...state, isDirty: action.payload };
    default:
      return state;
  }
};
